import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./App/store";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme/theme";
import { GlobalProvider } from "context/GlobalContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ModuleAccessNavProvider } from "context/ModuleAccessNavContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalProvider>
          <ModuleAccessNavProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <App />
            </LocalizationProvider>
          </ModuleAccessNavProvider>
        </GlobalProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
